import Register from "./components/Register";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout"
import Thanks from "./components/Thanks";

export const config = {
  endpoint: `https://qkart-frontend-lp23.onrender.com/api/v1`,
};

export default function App() {
  return (
    <div className="App">
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      {/* <Register /> */}
      <Switch>
        <Route path="/login" id="login" component={Login} />
        <Route path="/register" id="register" component={Register} />
        <Route path="/checkout" id="checkout" component={Checkout} />
        <Route path="/thanks" id="thanks" component={Thanks} />
        <Route path="/" id="products" component={Products} />
      </Switch>
    </div>
  );

// export default App;
  }